import { useCurrentUser } from "@/hooks/useCurrentUser";
import { useAuthModal } from "@/contexts/AuthModalContext";
// import { useVerificationModal } from "@/contexts/VerificationModalContext";

/**
 * Hook to create protected actions that require authentication
 * @returns Object with withAuth method to wrap actions that require authentication
 */
export function useProtectedAction() {
  const { user, isAuthenticated } = useCurrentUser();
  const { openAuthModal } = useAuthModal();
  // const { open: openVerificationModal } = useVerificationModal();

  /**
   * Wraps an action to ensure the user is authenticated before executing it
   * @param action Function to execute if authenticated
   * @param returnPath Optional path to return to after authentication
   * @returns A function that either executes the action or opens the auth modal
   */
  const withAuth = <T extends (...args: any[]) => any>(action: T, returnPath?: string) => {
    return (...args: Parameters<T>): ReturnType<T> | void => {
      if (!isAuthenticated) {
        openAuthModal(returnPath);
        return undefined as any;
      }
      // Temporarily disabled email verification guard
      // if (!user?.emailVerified) {
      //   openVerificationModal();
      //   return undefined as any;
      // }
      return action(...args);
    };
  };

  return { withAuth, isAuthenticated, user };
}
